import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router"
import { Routes, Route } from 'react-router';
import Header from './header';
import Notes from './Notes';
import CV from './CV';
import Blog from './Blog';
import BlogPost from './BlogPost';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
  <Header/>
    <Routes>
      <Route path="/" element={<App />} />
      <Route path="/about" element={<CV />} />
      <Route path="/notes" element={<Notes/>} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
